// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__1EA25","icon":"Alert_icon__UrLZS"};